module.exports = __webpack_public_path__ + "img/about_img.57808d28.jpg";